module.exports = __webpack_public_path__ + "static/media/damacai-3x.684acae5.png";